export default "<sizing-sizing-shared-lib></sizing-sizing-shared-lib>\r\n<router-outlet></router-outlet>\r\n"